/* @flow */
import * as React from 'react';
import { css } from 'linaria';

import { Card, Grid, GridCell, Icon, Text } from '../../../components/core';
import Colors from '../../../constants/Colors';
import Responsive from '../../../constants/Responsive';
// import ServiceCard from '../../../components/ServiceCard';

const NavTabs = {
  'store-delivery': {
    icon: 'price-tag',
    title: 'Store delivery',
  },
  'small-moves': {
    icon: 'home',
    title: 'Small moves',
  },
  'craigslist-delivery': {
    icon: 'handshake',
    title: 'Craigslist delivery',
  },
  'storage-moves': {
    icon: 'storage',
    title: 'Storage moves',
  },
  donations: {
    icon: 'donation',
    title: 'Donations',
  },
  'junk-removal': {
    icon: 'junk-removal',
    title: 'Junk removal',
  },
};

export type ServicesPageChromeFooterNavTabId = $Keys<typeof NavTabs>;

function ServicesPageChromeFooterNavTab({ tabId }: { tabId: ServicesPageChromeFooterNavTabId }) {
  let { title, icon } = NavTabs[tabId];
  return (
    <Card className={Styles.FooterNavCard} to={`/services/${tabId}`}>
      <Icon name={icon} className={Styles.FooterNavIcon} />
      <div className={Styles.FooterNavTitleFrame}>
        <Text size="17" color={Colors.Black} weight="bold">
          {title}
        </Text>
      </div>
      <Icon name="arrow-big-indigo-right" />
    </Card>
  );
}

function ServicesPageChromeFooterNav({
  selectedTab,
}: {
  selectedTab: ServicesPageChromeFooterNavTabId,
}) {
  return (
    <Grid hAlign="center" equalHeight={true} className={Styles.Grid}>
      {Object.keys(NavTabs)
        .filter(tabId => selectedTab !== tabId)
        .map(tabId => (
          <GridCell size={Responsive('size6of12', 'size4of12', 'size1of5')} key={tabId}>
            <ServicesPageChromeFooterNavTab tabId={tabId} key={tabId} />
          </GridCell>
        ))}
    </Grid>
  );
}

const Styles = {
  Grid: css``,
  FooterNavIcon: css`
    margin-top: -57px;
  `,
  FooterNavCard: css`
    display: flex;
    flex-direction: column;
    min-height: 160px;
    margin: 57px 12px 12px;
    width: 100%;
    background-color: ${Colors.opacity('#F8F8F9', 0.5)};
    border-radius: 10px;
    padding-top: 0;
    padding-left: 10px;
    padding-right: 10px;
    transition: background-color, box-shadow 300ms ease;
    &:hover {
      background-color: ${Colors.White};
      box-shadow: 0 12px 40px 0 rgba(0, 0, 0, 0.05);
      transform: none;
    }
  `,
  FooterNavTitleFrame: css`
    flex: 1;
    display: flex;
    align-items: center;
  `,
};

export default ServicesPageChromeFooterNav;



// WEBPACK FOOTER //
// ./src/ui/pages/ServicesPage/components/ServicesPageChromeFooterNav.js